// extracted by mini-css-extract-plugin
export default {"badge":"BadgeLayout_badge__9FHCr","withBorder":"BadgeLayout_withBorder__1HPVY"};